import Vue from 'vue'
import CrumbLayout from './crumbLayout.vue'

Vue.component('CrumbLayout', CrumbLayout)